import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73e134e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "account-selection" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "accountsHeading" }, "Accounts", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = { class: "accountRow" }
const _hoisted_7 = ["name", "checked"]
const _hoisted_8 = { class: "account" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel_group = _resolveComponent("panel-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_panel_group, { "show-heading": _ctx.heading }, {
        heading: _withCtx(() => [
          _hoisted_3,
          (_ctx.selectable)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAll()))
                }, "Select all")
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
            return (_openBlock(), _createElementBlock("div", {
              id: `sub-${account.subscriptionKey}`,
              class: "accountsContainer",
              key: account.subscriptionKey,
              onClick: ($event: any) => (_ctx.toggle(account.subscriptionKey))
            }, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.selectable)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      name: account.subscriptionKey,
                      type: "checkbox",
                      class: "accountCheck",
                      checked: _ctx.sa.includes(account.subscriptionKey)
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, _toDisplayString(account.productName), 1),
                  _createElementVNode("div", null, _toDisplayString(`**** ${account.accountNumber.substring(
                    account.accountNumber.length - 4
                  )}`), 1)
                ])
              ])
            ], 8, _hoisted_5))
          }), 128))
        ]),
        _: 1
      }, 8, ["show-heading"])
    ])
  ]))
}